import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import Navbar from "@/components/Navbar";
import { PasswordInput } from "@/components/PasswordInput";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [params] = useSearchParams();
  const next = params.get("next");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      toast.success(`Bienvenido, ${u.nombre}`);
      const map = { plaza_admin: "/admin", tienda: "/tienda", repartidor: "/repartidor", cliente: "/cliente", neni: "/neni" };
      nav(next || map[u.role] || "/");
    } catch (e) {
      toast.error(e.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F9F9F8]">
      <Navbar />
      <div className="max-w-md mx-auto px-6 py-16">
        <div className="overline text-zinc-500">Acceso</div>
        <h1 className="font-display font-black text-4xl tracking-tighter mt-1">Entrar</h1>
        <p className="text-sm text-zinc-500 mt-2">Accede a tu cuenta de en 90 MINUTOS</p>

        <form onSubmit={onSubmit} className="mt-8 space-y-4">
          <div>
            <Label htmlFor="email">Celular (o email)</Label>
            <Input id="email" data-testid="login-email" type="text" inputMode="tel" autoComplete="username" placeholder="10 dígitos" value={email} onChange={e => setEmail(e.target.value)} required className="mt-1 rounded-sm h-11" />
          </div>
          <div>
            <Label htmlFor="password">Contraseña</Label>
            <PasswordInput id="password" testId="login-password" value={password} onChange={e => setPassword(e.target.value)} required className="mt-1 rounded-sm h-11" />
          </div>
          <Button type="submit" data-testid="login-submit" disabled={loading} className="w-full h-11 rounded-sm bg-[#FF3366] hover:bg-[#E62958]">
            {loading ? "Entrando…" : "Entrar"}
          </Button>
        </form>

        <div className="mt-6 text-center text-sm text-zinc-600">
          ¿No tienes cuenta? <Link to="/register" className="text-[#FF3366] font-medium hover:underline">Regístrate</Link>
        </div>

        <details className="mt-8 border border-zinc-200 rounded-sm p-4 bg-white">
          <summary className="cursor-pointer text-xs uppercase tracking-wider font-medium text-zinc-500">Cuentas demo</summary>
          <div className="mt-3 space-y-1.5 text-xs font-mono">
            <div className="text-zinc-500 mb-1">Puedes entrar con celular o email</div>
            <div>👑 Admin: ricardozermeno1971@gmail.com / Plaza2026!</div>
            <div>🏪 Tienda: tienda@demo.com / Demo2026!</div>
            <div>🛍️ Cliente: cliente@demo.com / Demo2026!</div>
            <div>🛵 Repartidor: repartidor@demo.com / Demo2026!</div>
          </div>
        </details>
      </div>
    </div>
  );
}
